/**
 * Searchnav items reducer.
 * @module reducers/searchnav/searchnav
 */

import { flattenToAppURL, getBaseUrl } from '@plone/volto/helpers/Url/Url';
import { hasApiExpander } from '@plone/volto/helpers/Utils/Utils';

import { GET_CONTENT } from '@plone/volto/constants/ActionTypes';
import { GET_SEARCHNAV } from '@fhnw/constants/ActionTypes';

const initialState = {
  error: null,
  items: [],
  loaded: false,
  loading: false,
};

/**
 * Searchnav reducer.
 * @function searchnav
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export default function searchnav(state: any = initialState, action: any = {}) {
  let hasExpander;
  switch (action.type) {
    case `${GET_SEARCHNAV}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
      };
    case `${GET_CONTENT}_SUCCESS`:
      hasExpander = hasApiExpander(
        'searchnav',
        getBaseUrl(flattenToAppURL(action.result['@id'])),
      );
      if (hasExpander && !action.subrequest) {
        return {
          ...state,
          error: null,
          items: action.result['@components'].searchnav,
          loaded: true,
          loading: false,
        };
      } else {
        // It's a route change, so we nullify the state
        return {
          ...state,
          error: null,
          items: [],
          loaded: false,
          loading: false,
        };
      }
    case `${GET_SEARCHNAV}_SUCCESS`:
      // Even if the expander is set or not, if the GET_SEARCHNAV is
      // called, we want it to store the data if the actions data is
      // not set in the expander data (['@components']) but in the "normal"
      // action result (we look for the object property returned by the endpoint)
      if (!action.result?.['@components'] && action.result) {
        return {
          ...state,
          error: null,
          items: action.result,
          loaded: true,
          loading: false,
        };
      }
      return state;
    case `${GET_SEARCHNAV}_FAIL`:
      return {
        ...state,
        error: action.error,
        items: [],
        loaded: false,
        loading: false,
      };
    default:
      return state;
  }
}
